// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__AJesy","actions":"GroupTable_actions__1m2Lw","deleteModalFooter":"GroupTable_deleteModalFooter__3NJ0U"};